/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![EnvelopeIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABJElEQVR4nO2VPU7DQBCFLRBcBBqoUnKJ+aFYZpQDuEVKk9LpsJCAi8AhoCIVl4AKWhQpDWgSOZ6NncSyTYMy0lTeed97u147SfbVpEIIx8ByDyRfyPrTreUTSO/SND1aAZDlobuwRm2QEkD61DcAWR5XgCzLDoAlRdbvzsIkMyAZhxAOK2fBLCfA+tx6W1hemeWsIgykt8WDVmkodm1apukOuXZRozTgXK+biwFuADGc70xDsSGAcAqsL35NLcANT4p3eT2Nd20AZLmuM7EZUAq9EQ0HTmhkXbi2pEAy3TS/E7C8MDJH1tzfTAPY9ljSbbONAFiCpnB5dbHoLa5bA7BF/yMAsHz8AeDdJ8j7BgDpTfTDMUgfSWCpkZtm5aO3r6SmfgFET7zN4NugnQAAAABJRU5ErkJggg==)
 */
export const EnvelopeIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M1.16 5.02c-.1.28.04.58.29.74l10.27 6.85a.5.5 0 0 0 .56 0l10.27-6.85c.25-.16.38-.46.29-.74A3 3 0 0 0 20 3H4a3 3 0 0 0-2.84 2.02Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M23 8.8a.5.5 0 0 0-.78-.41l-9.53 6.35c-.42.28-.96.28-1.38 0L1.78 8.39A.5.5 0 0 0 1 8.8V18a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V8.8Z"
        className={colorClass}
      />
    </svg>
  );
};
